import { Component, Inject, ViewChild, ElementRef } from '@angular/core';
import { FormControl, NgModel } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogBase, T4Image, ImageType } from 't4core';
import * as uuid from 'uuid';

@Component({
    selector: 'contactInfoDialog',
    templateUrl: 'contactInfoDialog.html',
    styleUrls: ['./contactInfoDialog.css']
})
export class ContactInfoDialog extends DialogBase {

    @ViewChild("txtcontactFirstName", { static: false }) public txtcontactFirstName: NgModel;
    @ViewChild("txtcontactLastName", { static: false }) public txtcontactLastName: NgModel;
    @ViewChild("txtcontactEmail", { static: false }) public txtcontactEmail: NgModel;
    @ViewChild("txtcontactPhone", { static: false }) public txtcontactPhone: NgModel;

    constructor(
        public dialogRef: MatDialogRef<ContactInfoDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        super("ContactInfoDialog");

    }

    public async ngOnInit() {
        this.loading = true;
        this.loading = false;
    }

    public removeImage(id: string) {
        this.loading = true;
        this.loading = false;
    }

    public save() {
        this.dialogRef.close(this.data);
    }
}
